import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo, useEffect } from 'react';
import { RfpContainer } from '@/components/modules/pages/rfp/Layout/RfpContainer';
import { RfpProfessionalQuestionList } from '@/components/modules/pages/rfp/professional/List/RfpProfessionalQuestionList';
import { RfpProfessionalQuestionInfo } from '@/components/modules/pages/rfp/professional/Surface/RfpProfessionalQuestionInfo';
import { RfpProfessionalQuestionListAction } from '@/components/modules/pages/rfp/professional/Surface/RfpProfessionalQuestionListAction';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer/ContentContainer';
import { CardWithTitle } from '@/components/ui/Surface/CardWithTitle';
import { BandHead } from '@/components/ui/Typography/Heading/BandHead';
import { scrollToWithHeaderHeight } from '@/helpers/ScrollUtils';
const contentMargin = 'mx-16 xl:mx-28';
export const ProfessionalRfpQuestionListView = (props) => {
    const { canAddQuestionCount, id, isCanAddQuestion, isDisclose, isDiscloseApproved, name, questionId, questionItems, title, } = props;
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/project/professional',
            text: '募集中のプロジェクト',
        },
        {
            link: `/project/professional/${id}`,
            text: name,
        },
        {
            text: title,
        },
    ], [id, name, title]);
    // URLに質問IDがあれば、対象の質問まで自動スクロールさせる
    useEffect(() => {
        if (!questionId) {
            return;
        }
        scrollToWithHeaderHeight(`rfp_question_list_content_row_${questionId}`);
    }, [questionId]);
    return (_jsx(RfpContainer, Object.assign({ breadcrumbs: pans, className: 'mb-32', isFull: true, titleComponent: _jsx(BandHead, Object.assign({ bgColor: 'gradientDarkGreen', className: 'mb-32' }, { children: _jsx(ContentContainer, Object.assign({ className: 'flex justify-center md:justify-left mx-auto', maxWidthPoint: 'xl' }, { children: _jsx("span", Object.assign({ className: 'text-left md:text-center' }, { children: name })) })) })) }, { children: _jsx(CardWithTitle, Object.assign({ className: 'mb-28 w-full max-w-[830px]', isRounded: true, title: title }, { children: _jsxs("div", Object.assign({ className: 'pt-28 pb-12' }, { children: [_jsx(RfpProfessionalQuestionInfo, { className: contentMargin, id: id, isCanAddQuestion: isCanAddQuestion, isDisclose: isDisclose, isDiscloseApproved: isDiscloseApproved }), _jsx(RfpProfessionalQuestionList, { className: contentMargin, items: questionItems }), isCanAddQuestion && (_jsxs(_Fragment, { children: [_jsx("div", { className: 'w-full h-[1px] bg-gray-100' }), _jsx(RfpProfessionalQuestionListAction, { canAddQuestionCount: canAddQuestionCount, className: clsx('py-28', contentMargin), id: id })] }))] })) })) })));
};
